import React from 'react';
import { Modal, Spin } from 'antd';
import { connect } from 'react-redux';
import FullPageLoading from '../../../component/FullPageLoading';
import AnnualReviewReportContent from './AnnualReviewReportContent';
import {
  closeAnnualReviewReport,
  setClientType,
  fetchAnnualReviewReport,
  annualReviewReportSelector,
} from '../actions';
import s from '../AnnualReviewReport.module.scss';

const AnnualReviewReportModal = ({
  isModalOpen,
  isLoading,
  data,
  clientType,
  dateRange,
  isLoggedIn,
  closeAnnualReviewReport: onClose,
  setClientType: onClientTypeChange,
  fetchAnnualReviewReport: onFetchReport,
}) => {
  if (!isLoggedIn || !isModalOpen) {
    return null;
  }

  return (
    <Modal
      title="Annual Review Report"
      visible
      onCancel={onClose}
      footer={null}
      width="100%"
      style={{ top: 0, paddingBottom: 0 }}
      bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
      destroyOnClose
      closable
      maskClosable={false}
      aria-label="Annual Review Report modal"
    >
      {isLoading && !data ? (
        <FullPageLoading />
      ) : (
        <div className={s.reportShell}>
          {!!isLoading && (
            <div
              className={s.refreshOverlay}
              role="status"
              aria-live="polite"
              aria-busy="true"
            >
              <Spin tip="Refreshing report..." size="large" />
            </div>
          )}
          <div className={s.reportBody} aria-busy={!!isLoading}>
            <AnnualReviewReportContent
              data={data}
              clientType={clientType}
              dateRange={dateRange}
              onClientTypeChange={onClientTypeChange}
              onPeriodChange={onFetchReport}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

const mapStateToProps = state => {
  const { isModalOpen, isLoading, data, clientType, dateRange } =
    annualReviewReportSelector(state) || {};
  const { authStatus, isAdmin } = state.auth || {};
  return {
    isModalOpen: !!isModalOpen,
    isLoading: !!isLoading,
    data,
    clientType,
    dateRange,
    isLoggedIn: authStatus !== 'signout' && isAdmin === true,
  };
};

const mapDispatchToProps = {
  closeAnnualReviewReport,
  setClientType,
  fetchAnnualReviewReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnualReviewReportModal);
